import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query teams {
  teams {
    id
    name
    description
    visibleCasesCount,
    activitySearchTeams,
    activitySearchTeamIds,
    overseers {
      id
      fullName
    }
    operators {
      id
      fullName
    }
    requestTypePriorities {
      id
      channel {
        id
        name
        type
      }
      requestType{
        id
        name
      }
    }
  }
}`;

function getTeams() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.teams);
}

export default getTeams;
